import React, { useCallback, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import UploadService from "../../../Services/FileUploadServices";

const ImageUploadModal = ({ setBrandingData, brandingData }) => {
  const [showDropzone, setShowDropzone] = useState(true);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [showUploadFiles, setShowUploadFiles] = useState(false);
  const [selectFile, setSelectFile] = useState("");
  const [errorMsg, setErrorMsg] = useState(null);

  const closeModalRef = useRef(null);
  const [previewUpload, setPreviewUpload] = useState("");
  const token = useSelector((state) => state.auth.token);
  const [progress, setProgress] = useState(0);
  const [showProgress, setshowProgress] = useState(false);

  const personalize_brandingData = useSelector(
    (state) => state.personalize.personalize_brandingData
  );

  const [brandingLogo, setBrandingLogo] = useState({
    player_logo: personalize_brandingData.player_logo
      ? personalize_brandingData.player_logo
      : "",
  });

  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const focusedStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#000000",
  };

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  function filesizeValidator(file) {
    if (file.size > 15728640) {
      return {
        code: "file-too-large",
        message: `File Size should not be more than ${formatBytes(15728640)}`,
      };
    }

    return null;
  }

  const onDrop = useCallback(async (acceptedFiles) => {
    try {
      setShowDropzone(false);
      setShowUploadFiles(true);
      let imageDataUrl = await readFile(acceptedFiles[0]);
      console.log(imageDataUrl);
      // setUploadFiles(uploadFiles => [...uploadFiles, imageDataUrl]);
      setPreviewUpload(imageDataUrl);
      setUploadFiles(acceptedFiles);
    } catch (err) {
      console.log(err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    getRootProps: getRootFirstProps,
    getInputProps: getInputFirstProps,
    isFocused,
    isDragAccept,
    isDragReject,
    fileRejections,
  } = useDropzone({
    onDrop,
    accept: "image/jpeg,image/png,image/*",
    maxFiles: 1,
    validator: filesizeValidator,
  });

  const {
    getRootProps: getRootSecondaryProps,
    getInputProps: getInputSecondaryProps,
    fileRejections: fileRejectionsSecondaryUpload,
  } = useDropzone({
    accept: "image/jpeg,image/png,image/*",
    maxFiles: 1,
    onDrop,
    validator: filesizeValidator,
  });

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <div key={file.path}>
      {file.path} - {file.size} bytes
      <div className="d-inline-flex text-danger ms-sm-3">
        {errors.map((e) => (
          <span key={e.code}>{e.message}</span>
        ))}
      </div>
    </div>
  ));

  const fileRejectionSecondaryItems = fileRejectionsSecondaryUpload.map(
    ({ file, errors }) => (
      <div key={file.path}>
        {file.path} - {file.size} bytes
        <div className="d-inline-flex text-danger ms-sm-3">
          {errors.map((e) => (
            <span key={e.code}>{e.message}</span>
          ))}
        </div>
      </div>
    )
  );

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isFocused, isDragAccept, isDragReject]
  );

  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }

  const handleCancel = (event) => {
    event.preventDefault();
    setSelectFile("");
    closeModalRef.current.click();
  };

  const handleProcess = (event) => {
    event.preventDefault();
    setshowProgress(true);
    // selectFile && setBrandingLogo({...brandingLogo,player_logo:selectFile})

    UploadService.upload(selectFile, token, (event) => {
      setProgress(Math.round((100 * event.loaded) / event.total));
    })
      .then((response) => {
        // console.log(response.status);
        const imgLink = response.data.url;
        if (response.status === 200) {
          setBrandingLogo({ ...brandingLogo, player_logo: imgLink });
        }
        setshowProgress(false);
      })
      .catch(() => {
        setProgress(0);
        setErrorMsg("Something Went Wrong!!");
      });

    !selectFile && setErrorMsg("Please select file or upload new file.");
  };

  useEffect(() => {
    setBrandingData({ ...brandingData, player_logo: brandingLogo.player_logo });

    closeModalRef.current.click();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandingLogo]);

  return (
    <>
      {/* <!--import image popup start-->  */}
      <div
        className="modal popup1 fade"
        id="importimageBranding"
        style={{ background: "#000000ba" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Import Images
              </h5>
              <button
                type="button"
                className="close_btn"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ position: "inherit" }}
                ref={closeModalRef}
              >
                <i className="fa fa-close"></i>
              </button>
            </div>
            <div className="modal-body navpill_section p-4">
              <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active"
                    id="nav-local-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-local"
                    type="button"
                    role="tab"
                    aria-controls="nav-local"
                    aria-selected="true"
                  >
                    Local
                  </button>
                  {/* <button className="nav-link" id="nav-libraryimages-tab" data-bs-toggle="tab" data-bs-target="#nav-libraryimages" type="button" role="tab" aria-controls="nav-libraryimages" aria-selected="false">LIBRARY IMAGES</button> */}
                </div>
              </nav>
              <div className="tab-content p-4 pb-0" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="nav-local"
                  role="tabpanel"
                  aria-labelledby="nav-local-tab"
                >
                  <div className="v_c_import">
                    {showDropzone && (
                      <>
                        <div
                          className="image-upload"
                          {...getRootFirstProps({ style })}
                        >
                          <label
                            style={{ cursor: "pointer" }}
                            htmlFor="file_upload"
                          >
                            <div className="h-100">
                              <div className="dplay-tbl">
                                <div className="dplay-tbl-cell">
                                  <i>
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assets/images/upload.png"
                                      }
                                      className="img-fluid"
                                      alt="img"
                                    />
                                  </i>
                                  <input {...getInputFirstProps()} />
                                  <h6 className="pt-2 m-0">
                                    Drag &amp; drop your file here
                                  </h6>
                                </div>
                              </div>
                            </div>
                            {/* <!--upload-content-->  */}
                            {/* <input type="file" name="image_name" id="file_upload" className="image-input" data-traget-resolution="image_resolution" accept="video/quicktime,video/mp4,video/x-flv,video/*"/> */}
                          </label>
                        </div>
                        <div className="my-2">{fileRejectionItems}</div>
                      </>
                    )}

                    {showUploadFiles && (
                      <>
                        <div className="row import-media-container">
                          {uploadFiles &&
                            uploadFiles.length > 0 &&
                            uploadFiles.map((image) => (
                              <div
                                className={`rv_col localfile text-center p-0 ${
                                  selectFile === image ? "selected" : ""
                                }`}
                                key={image.length}
                              >
                                <button
                                  className="d-block border-0 bg-transparent mx-auto p-0"
                                  onClick={() => setSelectFile(image)}
                                >
                                  <span className="check_i">
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assets/images/check1.png"
                                      }
                                      className="img-fluid"
                                      alt="img"
                                    />
                                  </span>
                                  {/* <figure className="mt-2 mb-0"> */}
                                  <img
                                    src={previewUpload}
                                    alt="img"
                                    data-category="localfile"
                                  />
                                  {/* </figure> */}
                                </button>
                              </div>
                            ))}

                          {
                            <div
                              className="rv_col p-0 localfile text-center secondary-upload"
                              {...getRootSecondaryProps({})}
                            >
                              <button
                                className="d-block border-0 bg-transparent mx-auto p-0"
                                // onClick={(e)=>handleChange(e,'secondaryUpload')}
                              >
                                <figure className="my-0">
                                  {/* <input 
                                                                        type="file" 
                                                                        name="additional_files" 
                                                                        className="d-none" 
                                                                        accept="video/quicktime, video/mp4, video/x-flv, video/*"
                                                                    /> */}
                                  <input {...getInputSecondaryProps()} />
                                  <i className="fas fa-plus"></i>
                                </figure>
                              </button>
                            </div>
                          }
                        </div>
                        <div className="my-2">
                          {fileRejectionSecondaryItems}
                          {selectFile ? "" : errorMsg}
                        </div>
                      </>
                    )}

                    {showProgress && (
                      <div className="progress">
                        <div
                          className="progress-bar progress-bar-info progress-bar-striped"
                          role="progressbar"
                          aria-valuenow={progress}
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{ width: progress + "%" }}
                        >
                          {progress}%
                        </div>
                      </div>
                    )}

                    <div className="note_rw text-center pt-2 pb-3">
                      <span className="pink_clor">NOTE:</span> Supports JPEG,
                      PNG, BMP, formats with a maximum file of 5 MB
                    </div>
                    <div className="btn_wrap_p text-end">
                      <button className="btn btn2 me-2" onClick={handleCancel}>
                        Cancel
                      </button>
                      <button className="btn btn1" onClick={handleProcess}>
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="nav-libraryimages"
                  role="tabpanel"
                  aria-labelledby="nav-libraryimages-tab"
                >
                  <div className="recordedvideo">
                    <div className="row">
                      <div className="col-md-12 mb-4">
                        <div className="search_form ms-auto">
                          <form className="position-relative">
                            <input
                              name=""
                              type="text"
                              className="form-control"
                              placeholder="Enter name to search"
                            />
                            <button type="button">
                              <i className="fa fa-search"></i>
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-3 col-6">
                        <div className="rv_col mb-4">
                          <a href="#0" className="d-block">
                            <span className="check_i">
                              <img
                                src="images/check.png"
                                className="img-fluid"
                                alt="img"
                              />
                            </span>
                            <figure className="m-0">
                              <img
                                src="images/rv_img_1.jpg"
                                className="w-100"
                                alt="img"
                              />
                            </figure>
                            <figcaption className="p-2">
                              <h6 className="m-0">Thank You Video</h6>
                            </figcaption>
                          </a>
                        </div>
                      </div>
                      <div className="col-md-3 col-6">
                        <div className="rv_col mb-4">
                          <a href="#0" className="d-block">
                            <span className="check_i">
                              <img
                                src="images/check.png"
                                className="img-fluid"
                                alt="img"
                              />
                            </span>
                            <figure className="m-0">
                              <img
                                src="images/rv_img_2.jpg"
                                className="w-100"
                                alt="img"
                              />
                            </figure>
                            <figcaption className="p-2">
                              <h6 className="m-0">New Recording</h6>
                            </figcaption>
                          </a>
                        </div>
                      </div>
                      <div className="col-md-3 col-6">
                        <div className="rv_col mb-4">
                          <a href="#0" className="d-block">
                            <span className="check_i">
                              <img
                                src="images/check.png"
                                className="img-fluid"
                                alt="img"
                              />
                            </span>
                            <figure className="m-0">
                              <img
                                src="images/rv_img_3.jpg"
                                className="w-100"
                                alt="img"
                              />
                            </figure>
                            <figcaption className="p-2">
                              <h6 className="m-0">Facebook boosting</h6>
                            </figcaption>
                          </a>
                        </div>
                      </div>
                      <div className="col-md-3 col-6">
                        <div className="rv_col mb-4">
                          <a href="#0" className="d-block">
                            <span className="check_i">
                              <img
                                src="images/check.png"
                                className="img-fluid"
                                alt="img"
                              />
                            </span>
                            <figure className="m-0">
                              <img
                                src="images/rv_img_4.jpg"
                                className="w-100"
                                alt="img"
                              />
                            </figure>
                            <figcaption className="p-2">
                              <h6 className="m-0">Facebook boosting</h6>
                            </figcaption>
                          </a>
                        </div>
                      </div>
                      <div className="col-md-3 col-6">
                        <div className="rv_col mb-4">
                          <a href="#0" className="d-block">
                            <span className="check_i">
                              <img
                                src="images/check.png"
                                className="img-fluid"
                                alt="img"
                              />
                            </span>
                            <figure className="m-0">
                              <img
                                src="images/rv_img_5.jpg"
                                className="w-100"
                                alt="img"
                              />
                            </figure>
                            <figcaption className="p-2">
                              <h6 className="m-0">Business Development</h6>
                            </figcaption>
                          </a>
                        </div>
                      </div>
                      <div className="col-md-3 col-6">
                        <div className="rv_col mb-4">
                          <a href="#0" className="d-block">
                            <span className="check_i">
                              <img
                                src="images/check.png"
                                className="img-fluid"
                                alt="img"
                              />
                            </span>
                            <figure className="m-0">
                              <img
                                src="images/rv_img_6.jpg"
                                className="w-100"
                                alt="img"
                              />
                            </figure>
                            <figcaption className="p-2">
                              <h6 className="m-0">Marketing</h6>
                            </figcaption>
                          </a>
                        </div>
                      </div>
                      <div className="col-md-3 col-6">
                        <div className="rv_col mb-4">
                          <a href="#0" className="d-block">
                            <span className="check_i">
                              <img
                                src="images/check.png"
                                className="img-fluid"
                                alt="img"
                              />
                            </span>
                            <figure className="m-0">
                              <img
                                src="images/rv_img_7.jpg"
                                className="w-100"
                                alt="img"
                              />
                            </figure>
                            <figcaption className="p-2">
                              <h6 className="m-0">Marketing</h6>
                            </figcaption>
                          </a>
                        </div>
                      </div>
                      <div className="col-md-3 col-6">
                        <div className="rv_col mb-4">
                          <a href="#0" className="d-block">
                            <span className="check_i">
                              <img
                                src="images/check.png"
                                className="img-fluid"
                                alt="img"
                              />
                            </span>
                            <figure className="m-0">
                              <img
                                src="images/rv_img_8.jpg"
                                className="w-100"
                                alt="img"
                              />
                            </figure>
                            <figcaption className="p-2">
                              <h6 className="m-0">Marketing</h6>
                            </figcaption>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="iv_footer">
                      <div className="note_rw text-center pt-2 pb-3">
                        <span className="pink_clor">NOTE:</span> Supports JPEG,
                        PNG, BMP, formats with a maximum file of 10 MB
                      </div>
                      <div className="btn_wrap_p text-end">
                        <a href="#0" className="btn btn2 me-2">
                          Cancel
                        </a>
                        <a href="#0" className="btn btn1">
                          Proceed
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--import image popup end--> */}
    </>
  );
};

export default ImageUploadModal;
